import * as React from 'react';
import { Box } from '@material-ui/core';
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import "./styles.css";


export default function BidOptimization() {
  const [values, setValues] = React.useState({
    campaignBudget: "",
    dailyBudget: ""
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

    return (
      <div className="App">
        <div>
        <div
            style={{marginTop:20}}
            ></div>
          <Grid
                container
                direction="column"
                alignItems="center"
                >
                {/* <FormControl component="fieldset"> */}
                <FormLabel component="legend"></FormLabel>
            <Box
              component="form"
              sx={{ display: "flex", flexDirection: "column"}}>
  {/*}
                '& > :not(style)': { m: 1, width: '30ch' },
              }}
              noValidate
              autoComplete="off"
            >*/}
            <div style={{marginBottom:20}}>
              <FormControl fullWidth sx={{ m: 1 }}>
              <InputLabel shrink htmlFor="outlined-adornment-campaignBudget">Campaign Budget (Total Spend)</InputLabel>
              <OutlinedInput
                id="outlined-adornment-campaignBudget"
                value={values.campaignBudget}
                onChange={handleChange("campaignBudget")}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                type="number"
                inputlabelprops={{shrink: true}}
              />
              </FormControl>
            </div>
            <div style={{marginBottom:20}}>
              <FormControl fullWidth sx={{ m: 1 }}>
              <InputLabel shrink htmlFor="outlined-adornment-dailyBudget">Daily Budget (Total Daily Spend)</InputLabel>
              <OutlinedInput
                id="outlined-adornment-dailyBudget"
                value={values.dailyBudget}
                onChange={handleChange("dailyBudget")}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                type="number"
                inputlabelprops={{shrink: true}}
              />
              </FormControl>
            </div>
          </Box>
        </Grid>
        {console.log("campaign-budget: " + values.campaignBudget)}
        {console.log("daily-budget: " + values.dailyBudget)}
      </div>
    </div>
    );
  }
